<template>
  <div>
    <div class="myClass">
      <!-- <ul class="tabs">
        <li @click="changeCourseType(1)" :class="courseType == 1 ? 'classic active' : ''">公开课</li>
        <li @click="changeCourseType(2)" :class="courseType == 2 ? 'classic active' : ''">专业课</li>
      </ul> -->
      <div class="current-tabs">
        <div class="left-tabs">
          <div :class="['item',type == 0?'active':'']" @click="changeType(0)">我的全部课程</div>
          <div :class="['item',type == 1?'active':'']" @click="changeType(1)">已学习的课程</div>
        </div>
        <div class="input-box">
          <input type="text" v-model="courseName" placeholder="请输入课程名称">
          <div class="search-btn" @click="lodData()"></div>
        </div>
      </div>
      <div class="category-list-box">
        <!-- 一级分类 -->
        <!-- 首都师范大学第二附属中学 （我的课程列表隐藏一级分类） -->
        <div v-if="classCategory.length > 0 && school_code != utils.sdsfdx_code" class="category-list">
          <div v-on:click="oneClick(item.id, $event)" :class="['item',item.id == oneCateId?'active':'']" v-for="(item,index) in classCategory" :key="index">{{ item.name }}</div>
        </div>
        <!-- 二级分类 -->
        <div v-if="classCategory2.length > 0" class="category-list">
          <div v-on:click="twoClick(item.id, $event)" :class="['item',item.id == twoCateId?'active':'']" v-for="(item,index) in classCategory2" :key="index">{{ item.name }}</div>
        </div>
        <!-- 三级分类 -->
        <div v-if="classCategory3.length > 0" class="category-list">
          <div v-on:click="threeClick(item.id, $event)" :class="['item',item.id == threeCateId?'active':'']" v-for="(item,index) in classCategory3" :key="index">{{ item.name }}</div>
        </div>
      </div>

      <ul class="classContents">
        <!-- 学习中心 已下架class-list-grey 已完成iconwancheng  去掉待学习、 -->
        <li v-for="(item, i) in this.data" :key="i" :class="item.status == 3 || item.remaining_day == 0 ? 'disabled' : ''">
          <div class="classImages" @click="goClassDetails(item)">
            <!-- <span class="iconfont iconsuo" v-if="item.status == 1">{{item.status_name}}</span> -->
            <span class="iconfont class-list-grey" v-if="item.remaining_day == 0">已过期</span>
            <template v-else>
              <span class="iconfont iconwancheng" v-if="item.status == 2">{{item.status_name}}</span>
              <span class="iconfont class-list-grey" v-else-if="item.status == 3">{{item.status_name}}</span>
            </template>
            <img :src="item.photo" alt />
          </div>
          <div class="classInfo">
            <div class="info">
              <h3 @click="goClassDetails(item)">{{item.name}}</h3>
              <p>
                <span v-if="item.category_name" class="className">{{item.category_name}}</span>
                <span class="className">课程总时长：{{item.total_time}}</span>
                <span>{{school_code!='100004'?'课程讲师：':'授课专家：'}}{{item.teacher}}</span>
              </p>
              <p class="con">{{item.abstract}}</p>
              <div class="btm">
                <p class="residue" v-if="item.type != 1 && item.remaining_day != 0">
                  学习有效期剩余：
                  <span>{{item.remaining_day}}天</span>
                </p>
                <p class="residue residue-daoqi" v-if="item.type != 1 && item.remaining_day == 0">
                  <span>{{item.end_date}}已到期</span>
                </p>
                <p class="pre">
                  <span class="pre-label">学习进度：</span>
                  <a-progress :percent="item.learn_percent" />
                </p>
              </div>
            </div>
            <div class="rightButtom">
              <a-button v-if="item.remaining_day != 0 && item.status != 3" type="primary" shape="round" @click="classToDetail(item)">立即学习</a-button>
            </div>
          </div>
        </li>
      </ul>
      <div class="pages" v-if="this.data.length > 0">
        <a-pagination :defaultPageSize="10" @change="onChange" :locale="zhCN" :default-current="1" :total="this.num" :current="currentPage" />
      </div>
      <div v-else class="noData-box">
        <img src="@/assets/empty.png" alt="">
        <div class="text">暂无相关内容</div>
      </div>
    </div>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import { Button, Progress, Pagination } from "ant-design-vue";
import services from "../../../config/services";
import utils from "../../../config/utils";
import { mapState, mapActions } from "vuex";
export default {
  name: "MyClass",
  components: {
    AButton: Button,
    AProgress: Progress,
    APagination: Pagination,
  },
  data () {
    return {
      utils,
      data: [],
      num: 0,
      zhCN,
      services: services,
      courseType: 1,
      currentPage: 1,
      type: "0",// 默认查询已学课程 1已学 0全部
      courseName: "", // 课程名称
      school_code: localStorage.getItem("schoolCode"),
      root_id: 0,
      category_id: 0, // 当前选中的分类id 最深层级 默认为0全部
      categoryLevel: 1, // 分类级别 最多3级
      oneCateId: '',
      twoCateId: '',
      threeCateId: '',
    };
  },
  computed: {
    ...mapState({
      userAllInfo: state => state.appsLogin.appsUserInfo,
      classCategory: (state) => state.class.myClassCategory,
      classCategory2: (state) => state.class.myClassCategory2,
      classCategory3: (state) => state.class.myClassCategory3,
    }),
  },
  methods: {
    ...mapActions(["loadClassCategory"]),
    onChange (pageNumber) {
      this.lodData({
        page: pageNumber
      });
      this.currentPage = pageNumber;
    },
    classToDetail (item) {
      if (item.status != 3 && item.remaining_day != 0) {
        utils.redirect(this, `/${this.userAllInfo.school_code}/video/${item.id}/0?from=${this.$route.path}`, true);
      }
    },
    goClassDetails (item) {
      if (item.status != 3 && item.remaining_day != 0) {
        utils.redirect(this, `/${this.userAllInfo.school_code}/class/${item.id}`, true);
      }
    },
    lodData (params) {
      services.getUserCourseList({
        page: 1,
        size: 10,
        category_id: this.category_id,
        q: this.courseName,
        is_learn: this.type,
        // type: this.courseType,
        ...params,
      })
        .then((res) => {
          if (res.code === "0000") {
            this.data = res.data.items;
            this.num = res.data.total;
          }
          // this.imgCode = window.URL.createObjectURL(res);
        });
    },
    // changeCourseType (type) {
    //   if (type != this.courseType) {
    //     this.courseType = type;
    //     this.currentPage = 1;
    //     this.lodData({ page: 1 });
    //   }
    // },
    changeType (type) {
      if (type != this.type) {
        this.type = type
        this.currentPage = 1
        this.routeLink()
      }
    },

    oneClick (id) {
      this.oneCateId = id
      this.twoCateId = ''
      this.threeCateId = ''
      this.categoryLevel = 1
      this.routeLink()
    },
    twoClick (id) {
      this.twoCateId = id
      this.threeCateId = ''
      this.categoryLevel = 2
      this.routeLink()
    },
    threeClick (id) {
      this.threeCateId = id
      this.categoryLevel = 3
      this.routeLink()
    },

    // 跳转页面参数
    routeLink () {
      let param = {
        categoryLevel: this.categoryLevel,
        type: this.type
      }
      if (this.oneCateId) {
        param.oneCateId = this.oneCateId
      }
      if (this.twoCateId) {
        param.twoCateId = this.twoCateId
      }
      if (this.threeCateId) {
        param.threeCateId = this.threeCateId
      }
      let routeUrl = this.$router.resolve({
        path: `/${this.school_code}/user/myClass`,
        query: param
      });
      window.open(routeUrl.href, '_self');
    }
  },

  async mounted () {
    this.$store.commit("setNavTitle", {
      navTitle: "学习中心",
    });

    let init_root_id = 0
    let init_level = 1

    // 100046 山西研学 不显示一级（直接根据一级id:"346" 写死拿二级）
    // 100044 朝来农艺园 不显示一级（直接根据一级id:"363" 写死拿二级）
    if (process.env.NODE_ENV != 'development' && process.env.VUE_APP_FLAG === 'pro') {
      if (this.school_code == 100046) {
        init_root_id = 346
        init_level = 2
      } else if (this.school_code == 100044) {
        init_root_id = 363
        init_level = 2
      }
    } else {
      if (this.school_code == 100046) {
        init_root_id = 71
        init_level = 2
      } else if (this.school_code == 100044) {
        init_root_id = 363
        init_level = 2
      }
    }

    let newObj = Object.keys(this.$route.query);
    await this.loadClassCategory({ root_id: init_root_id, level: init_level });
    if (newObj.length > 0) {
      if (this.$route.query.type) {
        this.type = this.$route.query.type
      }
      if (this.$route.query.categoryLevel) {
        this.categoryLevel = this.$route.query.categoryLevel
      }
      if (this.$route.query.oneCateId) {
        this.oneCateId = this.$route.query.oneCateId
        this.category_id = this.oneCateId
        this.root_id = this.oneCateId
        // 100041只显示二级分类，不需要再显示其他分类
        // 100046 山西研学 不显示一级（直接根据一级id:"346" 写死拿二级）=> 已经拿过一次二级分类，不用再次请求
        if (this.school_code != 100041 && this.school_code != 100046) await this.loadClassCategory({ root_id: this.root_id, level: 2 });
      }
      if (this.$route.query.twoCateId) {
        this.twoCateId = this.$route.query.twoCateId
        this.category_id = this.twoCateId
        this.root_id = this.twoCateId
        // 100041只显示二级分类，不需要再显示其他分类
        if (this.school_code != 100041) await this.loadClassCategory({ root_id: this.root_id, level: 3 });
      }
      if (this.$route.query.threeCateId) {
        this.threeCateId = this.$route.query.threeCateId
        this.category_id = this.threeCateId
      }
    }
    await this.lodData({ page: 1 });
  },
};
</script>
<style lang="less" scoped>
.major-box {
    width: 100%;
    .major-items {
        width: 60px;
        height: 28px;
        background: inherit;
        background-color: rgba(36, 98, 245, 1);
        border-radius: 6px;
        color: #ffffff;
    }
}
.noData-box {
    width: 100%;
    text-align: center;
    height: 770px;
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 150px;
    img {
        width: 240px;
        height: auto;
        margin: 0 auto 30px;
    }
    .text {
        color: #76797e;
        font-size: 14px;
    }
}
.myClass {
    .current-tabs {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 26px;
        border-bottom: 1px solid #eceff1;
        .left-tabs {
            display: flex;
            .item {
                cursor: pointer;
                padding-bottom: 18px;
                font-size: 16px;
                color: #545c63;
                &:not(:last-child) {
                    margin-right: 45px;
                }
                &.active {
                    color: #125cfd;
                    border-bottom: 2px solid #125cfd;
                }
            }
        }
        .input-box {
            position: relative;
            top: -5px;
            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                width: 1px;
                height: 18px;
                background: #e1e4e8;
                top: 50%;
                transform: translateY(-50%);
                right: 38px;
            }
            .search-btn {
                display: inline-block;
                position: absolute;
                background-image: url('../../../assets/search.png');
                width: 17px;
                height: 17px;
                background-size: cover;
                top: 50%;
                right: 10px;
                transform: translateY(-50%);
                cursor: pointer;
            }
            input {
                width: 257px;
                height: 33px;
                background: #f6f7fb;
                border: 1px solid #f6f7fb;
                padding: 0 32px 0 16px;
                color: #545c63;
                font-size: 14px;
                border: 1px solid #dcdee4;
                &::placeholder {
                    color: #c0c0c0;
                }
            }
        }
    }
}
.category-list-box {
    margin: 24px 0 0;
    .category-list {
        display: flex;
        flex-wrap: wrap;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
        .item {
            padding: 3.5px 18.5px;
            text-align: center;
            cursor: pointer;
            margin: 0 8px 8px 0;
            font-size: 14px;
            background: #fff9eb;
            border-radius: 2px;
            color: #6c675d;
            &.active {
                background: #f29d09;
                color: #fff;
            }
        }
    }
}

ul.classContents {
    li {
        .classInfo {
            padding: 28px 0 17px 0;
            .info {
                p:not(.con) {
                    margin: 6px 0 0 1px;
                }
                p.con {
                    color: #bababa;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    line-height: 16px;
                    height: 32px;
                    margin-bottom: 1px;
                }
            }
        }
    }
}
</style>